<div class="modal-content-container">

  <section class="header-container">
    <div class="animated fadeInUp img-mushroom d-none d-lg-block d-md-block d-sm-none"></div>
    <div class="animated fadeInDown img-peaches d-none d-lg-block d-md-block d-sm-none"></div>
    <header class="text-center d-flex flex-column gap-3">
      <h1 class="h1-bold">
        <p class="m-0">Not Quite Neighbors<span class="dot-is-blue">.</span></p>
      </h1>
    </header>

    <article class="text-center px-5 mt-3">
      Outside the zone — but not out of luck! We're planting roots in new places soon.
    </article>
  </section>

  <section class="mt-5 mb-3 form-container">
    <h6 class="h7-semibold mb-1">FIRST AND LAST NAME *</h6>
    <div class="form-floating has-validation">
      <input type="text" class="form-control" id="name" name="name" placeholder="Name"
        [class.is-invalid]="!prospectInformationValidations.get('name')?.()?.valid && prospectForm()?.name?.length > 0"
        [class.is-valid]="prospectInformationValidations.get('name')?.()?.valid && prospectForm()?.name?.length > 0"
        [ngModel]="prospectForm()?.name" (ngModelChange)="updateProspectForm({name: $event}, 'name')">
      <label for="name">Name</label>

      @if (!prospectInformationValidations.get('name')?.()?.valid && prospectForm()?.name?.length > 0) {
      <div class="invalid-feedback d-flex align-items-center">
        <i class="fas fa-exclamation-circle me-2"></i>
        {{ prospectInformationValidations.get('name')?.()?.error }}
      </div>
      } @else if (prospectInformationValidations.get('name')?.()?.valid && prospectForm()?.name?.length > 0) {
      <div class="valid-feedback d-flex align-items-center">
        <i class="fas fa-check-circle me-2"></i>
        Looks good!
      </div>
      }
    </div>
  </section>

  <section class="form-container">
    <h6 class="h7-semibold mb-1">
      EMAIL*
      <i class="fas fa-exclamation-circle text-primary"></i>
    </h6>
    <div class="form-floating has-validation">
      <input type="email" class="form-control" id="email" name="email" placeholder="email&#64;gmail.com"
        [class.is-invalid]="!prospectInformationValidations.get('email')?.()?.valid && prospectForm()?.email?.length > 0"
        [class.is-valid]="prospectInformationValidations.get('email')?.()?.valid && prospectForm()?.email?.length > 0"
        [ngModel]="prospectForm()?.email" (ngModelChange)="updateProspectForm({email: $event}, 'email')">
      <label for="email">email&#64;gmail.com</label>

      @if (!prospectInformationValidations.get('email')?.()?.valid && prospectForm()?.email?.length > 0) {
      <div class="invalid-feedback d-flex align-items-center">
        <i class="fas fa-exclamation-circle me-2"></i>
        {{ prospectInformationValidations.get('email')?.()?.error }}
      </div>
      } @else if (prospectInformationValidations.get('email')?.()?.valid && prospectForm()?.email?.length > 0) {
      <div class="valid-feedback d-flex align-items-center">
        <i class="fas fa-check-circle me-2"></i>
        Looks good!
      </div>
      }
    </div>
  </section>

  <div class="d-grid gap-2 col-md-8 mx-auto mt-5">
    <div class="row">
      <div class="col-md-6">
        <button type="button" class="btn btn-secondary rounded-pill w-100 py-3"
          [disabled]="!isValidFormProspectInformation()" (click)="addProspect()">Share Information</button>
      </div>
      <div class="col-md-6">
        <button type="button" class="btn btn-primary rounded-pill w-100 py-3" (click)="activeModal.close(false)">Try
          Another
          Address</button>
      </div>
    </div>
  </div>
</div>